import filterIcon from "@surgia/ui/icons/table/filter.svg";
import searchIcon from "@surgia/ui/icons/table/search.svg";
import { useTranslation } from "react-i18next";

interface TableToolbarProps {
  statusTabs: { label: string; value: string | undefined }[];
  currentStatus: string | undefined;
  onStatusChange: (value: string | undefined) => void;
  searchValue: string;
  onSearchChange: (value: string) => void;
  onFilterClick: () => void;
  showSearch?: boolean;
  children?: React.ReactNode;
  additionalChild?: React.ReactNode;
  additionalFilterStyle?: string;
  mainContainerStyle?: string;
  showFilter?: boolean;
}

const TableToolbar: React.FC<TableToolbarProps> = ({
  statusTabs,
  currentStatus,
  onStatusChange,
  searchValue,
  onSearchChange,
  onFilterClick,
  showSearch = true,
  children,
  additionalChild,
  additionalFilterStyle,
  mainContainerStyle,
  showFilter = true,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`flex items-center justify-between w-full gap-4 mb-4 px-4 ${mainContainerStyle}`}
    >
      {/* Status Tabs */}
      {statusTabs.length > 0 && (
        <div className="flex border rounded-md overflow-hidden">
          {statusTabs.map((tab) => (
            <button
              key={tab.value}
              className={`px-4 py-2 text-sm font-medium ${
                currentStatus === tab.value
                  ? "bg-gray-50 text-gray-900"
                  : "bg-white text-gray-500"
              } focus:outline-none`}
              onClick={() => onStatusChange(tab.value)}
              type="button"
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}
      {children}
      {/* Search and Filters */}
      <div className="flex items-center gap-2">
        {showSearch && (
          <div className="relative">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
              <img src={searchIcon} alt="search" />
            </span>
            <input
              className="pl-9 pr-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary w-[300px]"
              type="text"
              placeholder={t("shared.tableToolbar.searchPlaceholder")}
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
        )}
        {showFilter && (
          <div className={`flex gap-2 ${additionalFilterStyle}`}>
            <button
              type="button"
              className="flex items-center gap-1 px-4 py-2 border rounded-md text-sm text-gray-700 bg-white hover:bg-gray-50 w-fit "
              onClick={onFilterClick}
            >
              <img src={filterIcon} alt="filter" />
              {t("shared.tableToolbar.filters")}
            </button>
            {additionalChild}
          </div>
        )}
      </div>
    </div>
  );
};

export default TableToolbar;
